import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { templateQuestionApi } from '../../reducers/templateQuestionSlice';

import { Button, Col, Input, Row } from "reactstrap";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const QuestionListItem = ({ template, question }) => {
    const [editing, setEditing] = useState(false)
    const [deleting, setDeleting] = useState(false)
    const [body, setBody] = useState(question.body)

    const dispatch = useDispatch()

    useEffect(() => {
        // console.log(question.id, editing)
    }, [editing])

    const onSave = () => {
        dispatch(templateQuestionApi.update({
            templateId: template.id,
            question: { ...question, body: body }
        }))

        setEditing(false)
    }

    const showDeleteConfirm = () => {
        confirmAlert({
        //   title: 'Confirm to submit',
          message: "Sei sicuro di voler eliminare questa domanda ?",
          buttons: [
            {
              label: 'SI',
                onClick: () => { 
                    setDeleting(true)
                    dispatch( templateQuestionApi.delete({
                        templateId: template.id,
                        question: question
                    }) )
                }
            },
            {
                label: 'NO',
                onClick: () => {}
            }
          ]
        });
    }

    return (
        <>
            <Row style={{padding: "1em", borderBottom: "1px solid #f3f1f1", alignItems: 'center'}} >
                <Col md="11">
                    {
                        editing 
                        ? <Input type="textarea" rows="1" value={body} onChange={(event) => setBody(event.target.value)}/>
                        : body
                    }
                </Col>
                <Col md="1" style={{whiteSpace: 'nowrap'}}>
                    {
                        editing
                            ? <Button onClick={() => { onSave(); }} className="btn btn-success" > <i className="fas fa-check" /> </Button>
                            : <Button onClick={() => { setEditing(true) }} className="btn btn-primary " disabled={deleting} > <i className="fas fa-pencil-alt" /> </Button>
                    }
                    &nbsp;
                    {
                        editing
                            ? <Button onClick={() => { setBody(question.body); setEditing(false) }} className="btn btn-danger " disabled={deleting} > <i className="fas fa-times" /> </Button>
                            : <Button onClick={() => { showDeleteConfirm() }} className="btn btn-danger " disabled={deleting} > <i className="fas fa-trash-alt" /> </Button>
                    }
                </Col>
            </Row>
        </>
    )

};

export default QuestionListItem;